// @ts-nocheck
export const localeCodes =  [
  "uk"
]
export const localeLoaders = {
  uk: [
    {
      key: "locale_uk_46json_64c4b714",
      load: () => import("#nuxt-i18n/64c4b714" /* webpackChunkName: "locale_uk_46json_64c4b714" */),
      cache: true
    }
  ]
}
export const vueI18nConfigs = []
export const normalizedLocales = [
  {
    code: "uk",
    name: "UA",
    language: "uk-UA"
  }
]
/** client **/

/** client-end **/